import { IAssessmentByID, IData } from "@/@types";
import { getAxiosErrorMessage } from "@/resources";
import { useQuery } from "@tanstack/react-query";
import api from "../axios";

export function usGetAssessmentById(id: string) {
  const query = useQuery({
    queryKey: ["/assessment-by-id", id],
    queryFn: async () => {
      try {
        const { data } = await api.get<IData<IAssessmentByID>>(
          `/assessments/${id}`
        );

        return data;
      } catch (error) {
        throw new Error(getAxiosErrorMessage(error));
      }
    },
    enabled: !!id, // Só executar se tiver um ID
  });

  return query;
}
